import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { useAppDispatch } from 'store';
import { logoutAction } from 'store/actions/auth-actions';

const Logout = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const { instance } = useMsal();

  useEffect(() => {
    dispatch(logoutAction(true));
  }, [instance, dispatch]);

  return <div />;
};

export default Logout;
